import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const OrganizationsList = styled.div``
export const OrganizationsListRow = styled.div`
  display: grid;
  gap: ${Spacing.S16};
  grid-template-columns: 1fr 1fr 1fr;
  margin-right: -${Spacing.S24};
  margin-bottom: ${Spacing.S16};
`
